// Utils
import getAbsoluteBoundingRect from '../../utils/getAbsoluteBoundingRect'

export default
{
    name: 'app-language-selector',

    data()
    {
        return {

        }
    },

    created()
    {
        // Events
        this.eventHub.$on('app-footer:resized', this._onFooterResized)
        this.eventHub.$on('page:medias-loaded', this._onMediasOnPageLoaded)
        this.eventHub.$on('window:raf', this._onEnterFrame)

        // Variables
        this.$footer = null
        this._footerRect = null
        this._footerIsResized = false
        this._mediasAreLoaded = false
    },

    destroyed()
    {
        // Events
        this.eventHub.$off('app-footer:resized', this._onFooterResized)
        this.eventHub.$off('page:medias-loaded', this._onMediasOnPageLoaded)
        this.eventHub.$off('window:raf', this._onEnterFrame)
    },

    methods:
    {
        // Events
        _onFooterResized()
        {
            this._footerIsResized = true

            this._getFooterRect()
        },

        _onMediasOnPageLoaded()
        {
            this._mediasAreLoaded = true

            this._getFooterRect()
        },

        _onEnterFrame()
        {
            if (this.$footer
                && this._footerRect)
            {
                if (this.$root.width > this.$root.CONSTANTS.breakpoints.md)
                {
                    if (this.$root.smoothScroll + this.$root.height >= this._footerRect.top)
                    {
                        this.$el.style.transform = `translateY(${this._footerRect.top - (this.$root.smoothScroll + this.$root.height)}px) translateZ(0)`
                    }
                    else
                    {
                        this.$el.style.transform = 'translateY(0) translateZ(0)'
                    }
                }
                // else
                // {
                //
                // }
            }
        },

        // Getters
        _getFooterRect()
        {
            if (this._footerIsResized
                && this._mediasAreLoaded)
            {
                this.$footer = document.querySelector('.js-footer')

                if (this.$footer)
                {
                    this.$nextTick(() =>
                    {
                        this._footerRect = getAbsoluteBoundingRect(this.$footer)
                    })
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-language-selector/script.js